import * as React from "react";

import { cn } from "@frontend/shared/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "empty" | "filled";
}

const classNames =
  "w-1/3 rounded-full border-transparent focus:border-superscriptBlue focus:border-2 bg-gray-100 p-3 m-1 focus:outline-none focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 transition-all duration-300 placeholder:text-gray-400 font-light placeholder:font-light";
const filledClassNames = "border bg-white border-black";

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          variant === "empty" && classNames,
          variant === "filled" && `${classNames} ${filledClassNames}`,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
